import Loader from 'components/Loader';
import { useTransactions } from 'contexts/Transactions';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const TableShowMore = () => {
  const { loading, isLastPage, showMore } = useTransactions();

  const { t } = useTranslation('beneficiaries');

  if (isLastPage) return null;

  return (
    <div className="button-wrapper">
      <button disabled={loading} onClick={showMore} className="show-more-button" type="button">
        {loading ? (
          <Loader small />
        ) : (
          <>
            {t('show_more')}
            <span className="chevron" />
          </>
        )}
      </button>
    </div>
  );
};
